import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px 0;

	& > .ant-card {
		margin: 12px 0;
	}
`;

export const ItemsList = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
`;

export const ActionButton = styled.button`
	background: none;
	border: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 8px 0;
	height: 100%;
	cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
	opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

	&:hover {
		color: ${({ isDanger, isDisabled }) => {
			if (isDisabled) {
				return '#c2c2c2';
			}

			return isDanger ? 'var(--danger)' : 'var(--primary)';
		}};
	}

	& > i {
		margin-bottom: 4px;
		font-size: 17px;
	}
`;

export const RSSCardContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;

	& > header {
		width: 100%;
		display: flex;
		gap: 12px;
		align-items: center;

		& > div {
			display: flex;
			flex-direction: column;
			width: 100%;

			& > h3 {
				font-size: 16px;
				font-weight: 500;
				margin: 0;
				padding: 0;
			}

			& > small {
				font-size: 12px;
				opacity: 0.8;
			}
		}
	}

	& > div.tags {
		width: 100%;
		display: flex;
		gap: 18px;

		& > span {
			display: flex;
			align-items: center;
			font-size: 13px;
			opacity: 0.8;
			gap: 4px;
		}
	}

	& > a {
		font-size: 12px;
		opacity: 0.7;
		cursor: pointer;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;

		&:hover {
			color: var(--primary);
			opacity: 1;
			text-decoration: underline;
		}
	}
`;

export const UpdateFormContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

export const UpdateCoverImageContainer = styled.div`
	width: max-content;
	height: max-content;
	border-radius: 50%;
	position: relative;
	background: red;

	& > div.overlay {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		display: flex;
		position: absolute;
		top: 0;
		left: 0;
		align-items: center;
		justify-content: center;
		z-index: 20;
		cursor: pointer;

		& > span {
			opacity: 0.4;
			color: #fff;
		}

		&:hover {
			background: rgba(0, 0, 0, 0.4);

			& > span {
				opacity: 1;
			}
		}
	}
`;

export const PaginationContainer = styled.div`
	margin-top: 24px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const RssFeedDetailsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 18px;

	& > header {
		width: 100%;
		display: flex;
		gap: 12px;
		align-items: center;

		& > * {
			margin: 0;
		}
	}

	& > div.infos {
		width: 100%;
		display: flex;
		flex-direction: column;

		& > div {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 4px 0;
			border-bottom: 1px solid #dedede;

			& > span {
				font-size: 14px;
			}

			& > strong {
				font-size: 14px;
				font-weight: 500;
				display: flex;
				gap: 2px;
				align-items: center;
			}
		}
	}

	& > div.news {
		width: 100%;
		display: flex;
		flex-direction: column;

		& > ul {
			display: flex;
			flex-direction: column;
			gap: 6px;
			margin: 0;
			padding: 0;

			& > li {
				border: 1px solid #ccc;
				background-color: #f9f9f9;
				padding: 8px;
				border-radius: 4px;
				display: flex;
				flex-direction: column;
				gap: 6px;

				& > header {
					display: flex;
					flex-direction: column;

					& > small {
						font-size: 10px;
						opacity: 0.7;
						text-transform: uppercase;
					}

					& > strong {
						font-size: 16px;
						font-weight: 500;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				& > span {
					font-size: 13px;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				& > a {
					font-size: 13px;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
					margin-top: 4px;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
`;
